
		import {Fragment as _Fragment, jsx as _jsx, jsxs as _jsxs} from "dreamland/jsx-runtime";
export const title = "Giving up on the agentic dream";
export const description = "Or, why I've stopped “embracing exponentials.”";
export const tags = ["Personal", "Opinion"];
export const image = "/blog-images/go-longex.jpg";
function _createMdxContent(props) {
  const _components = {
    img: "img",
    p: "p",
    ...props.components
  };
  return _jsxs(_Fragment, {
    children: [_jsx(_components.p, {
      children: _jsx(_components.img, {
        src: "/blog-images/go-longex.jpg",
        alt: "stylized long exposure photograph of a commuter train"
      })
    }), "\n", _jsxs("cap", {
      children: [_jsxs("subt", {
        children: [_jsx("span", {
          class: "material-symbols",
          children: "info"
        }), "Image credit: Me."]
      }), _jsx("br", {}), _jsx("subt", {
        children: "Captured with Long Exposure mode on Pixel 8 Pro."
      })]
    }), "\n", _jsx(_components.p, {
      children: "Recently, I've grown pretty disillusioned with the promise of 10x'ing my productivity peddled by the companies selling AI coding agents."
    }), "\n", _jsx(_components.p, {
      children: "I've been trying my best to see what they have to offer. There's about two things I've found them useful for. First off, they're pretty good for lengthy, but ultimately menial tasks that don't require a whole lot of thinking (e.g. adding an attribute to a bunch of components, refactoring a stylesheet to use variables). Second, they're pretty good for quick and easy personal projects. I've created tons of cool little exploratory side projects with just a few prompts. And I won't lie, they really help scratch that “what if?” itch that previously took a good 6 hours of my time. Since I've delegated these minor side projects to AI, I've had more time to pursue other non-programming-related hobbies and passions. I think it's great for those purposes!"
    }), "\n", _jsx(_components.p, {
      children: "But I just can't see myself ever trying to use it for any serious work. I've tried using it to implement features both straightforward and complex. Hell, I even tried every combination of model and harness under the sun, so it's not like I'm “holding it wrong” or anything. Most times, I either had to make major modifications or I scrapped it and just did it by hand. And whenever it did do a passable job, I still had a nagging feeling that I could have done it better if I just locked in and did it myself."
    }), "\n", _jsx(_components.p, {
      children: "All in all, I strongly believe that agents are going to absolutely FUCK a decade of codebases, and we're gonna look back on all this in 2036 like Oppenheimer looked at the destruction his nukes caused."
    })]
  });
}
export function MDXContent(props = {}) {
  const {wrapper: MDXLayout} = props.components || ({});
  return MDXLayout ? _jsx(MDXLayout, {
    ...props,
    children: _jsx(_createMdxContent, {
      ...props
    })
  }) : _createMdxContent(props);
}


		export default function Page() {
			const {wrapper: MDXLayout} = this.components || ({});
			return (
				MDXLayout 
					? _jsx(MDXLayout, { children: [_createMdxContent(this)], ...this })
					: _createMdxContent(this)
			)
		}
	